import { Route } from '@angular/router'
import { BesoinDispatchComponent } from './besoin-dispatch.component'

export const BesoinDispatchComponentRouting: Route = {
  path: "dispatch-besoin",
  component: BesoinDispatchComponent,
  data: {
    breadcrumb: "Répartition de la livraison par lingerie"
  }
}
